'use client';
import styles from './cursorHoverMask.module.css';
import { useState } from 'react';
import { motion } from 'framer-motion';
import useMousePosition from './utils/useMousePosition';
import { Undo2 } from 'lucide-react';
import Link from 'next/link';

export default function Home() {
  const [isHovered, setIsHovered] = useState(false);
  const { x, y } = useMousePosition();
  const size = isHovered ? 400 : 40;

  return (
    <main className={styles.main}>
      <Link href='/projets'>
        <span className='flex items-center ps-6 pt-6 text-[#EC4E39] text-3xl hover:underline pointer z-100'>
          <Undo2 /> RETOUR{' '}
        </span>
      </Link>
      <motion.div
        className={styles.mask}
        animate={{
          WebkitMaskPosition: `${x - size / 2}px ${y - size / 2}px`,
          WebkitMaskSize: `${size}px`,
        }}
        transition={{ type: 'tween', ease: 'backOut', duration: 0.5 }}
      >
        <p
          onMouseEnter={() => {
            setIsHovered(true);
          }}
          onMouseLeave={() => {
            setIsHovered(false);
          }}
        >
          {/* A visual designer - with skills that haven't been replaced by A.I
          (yet) - making good shit only if the paycheck is equally good. */}
          Web Designer dont les compétences n'ont pas (encore) été remplacé par
          l'Intelligence Artificielle
        </p>
      </motion.div>

      <div className={styles.body}>
        <p>
          {/* I'm a <span>selectively skilled</span> product designer with strong
          focus on producing high quality & impactful digital experience. */}
          Mes <span>compétences avancées</span>, mettent l'accent sur la
          création d'expériences numériques de grande qualité et percutantes.
        </p>
      </div>
    </main>
  );
}
